/* ---------------------
 첫화면
 --------------------- */
import { isMobile } from '@/common/mobile';

function loadView(view) {
	// view가 지정되어 있지 않은 경우 공사중 안내 페이지 보이기
	if (!view || !view.length)
		return () => import('@/components/UnderConstruction');

	return () => {
		// 모바일이 아닌 경우 일반 화면을 보여줌
		if (!isMobile()) return import(`@/components/${view}`);

		// 모바일인 경우 모바일 컴포넘트 로드를 시도함
		if (view.includes('MerchantLayout')) {
			return import(`@/components/Layout/Layout.m`);
		} else {
			return import(`@/components/${view}.m`).catch(() =>
				// 모바일 컴포넌트가 존재하지 않은 경우 일반 컴포넌트로 fallback 처리
				import(`@/components/${view}`),
			);
		}
	};
}

const emptyComponent = {
	render() {
		return <router-view></router-view>;
	},
};

export const routes = [
	{
		path: '/',
		name: 'Layout-home',
		component: loadView('Layout/Layout'),
		meta: { auth: false },
		children: [
			{
				path: '',
				name: 'home',
				meta: { auth: false },
				component: loadView('Home'),
				redirect: { name: 'pay-payment' },
			},
			{
				path: '/cookies',
				name: 'cookies',
				meta: { auth: false },
				component: loadView('Cookies'),
			},
			{
				path: '/development',
				name: 'development',
				meta: { auth: false },
				component: loadView('Development/Development'),
			},
		],
	},

	/* ---------------------
		로그인 / 회원가입
		--------------------- */
	{
		path: '/auth',
		name: 'auth',
		meta: { auth: false },
		component: loadView('Layout/Layout'),
		children: [
			{
				path: 'login',
				name: 'auth-login',
				component: loadView('Auth/Login'),
				meta: { auth: false },
			},
			{
				path: 'find-account',
				name: 'auth-find-account',
				component: loadView('Auth/FindAccount'),
				meta: { auth: false },
			},
			{
				path: 'logout',
				name: 'auth-logout',
				component: loadView('Auth/Logout'),
				meta: { auth: true },
			},
			{
				path: 'register',
				name: 'auth-register',
				component: loadView('Auth/Register'),
				meta: { auth: false },
			},
			{
				path: 'dashboard',
				name: 'auth-dashboard',
				component: loadView('Auth/Dashboard'),
				meta: { auth: true },
				redirect: { name: 'wallet_account-assets' },
			},
		],
	},
	{
		path: '/personal',
		name: 'personal',
		component: loadView('Layout/Layout'),
		redirect: { name: 'personal-how-online_shopping' },
		props: { sub_page: true },
		meta: { auth: false },
		children: [
			{
				path: 'how',
				meta: { auth: false },
				component: emptyComponent,
				children: [
					{
						path: 'online_shopping',
						name: 'personal-how-online_shopping',
						component: loadView('Service/Personal/How/OnlineShopping'),
						meta: { auth: false },
					},
					{
						path: 'offline_kiosk',
						name: 'personal-how-offline_kiosk',
						component: loadView('Service/Personal/How/OfflineKiosk'),
						meta: { auth: false },
					},
					{
						path: 'qr',
						name: 'personal-how-qr',
						component: loadView('Service/Personal/How/Qr'),
						meta: { auth: false },
					},
					{
						path: 'janopay_creditcard',
						name: 'personal-how-janopay_creditcard',
						component: loadView('Service/Personal/How/JanopayCreditcard'),
						meta: { auth: false },
					},
					{
						path: 'trade_and_cashback',
						name: 'personal-how-trade_and_cashback',
						component: loadView('Service/Personal/How/TradeAndCashback'),
						meta: { auth: false },
					},
				],
			},
			{
				path: 'request',
				name: 'personal-request',
				component: emptyComponent,
				redirect: { name: 'personal-request-send' },
				meta: { auth: false },
				children: [
					{
						path: 'send',
						name: 'personal-request-send',
						component: loadView('Service/Personal/Request/Send'),
						meta: { auth: false },
					},
					{
						path: 'receive',
						name: 'personal-request-receive',
						component: loadView('Service/Personal/Request/Receive'),
						meta: { auth: false },
					},
					{
						path: 'deposit',
						name: 'personal-request-deposit',
						component: loadView('Service/Personal/Request/Deposit'),
						meta: { auth: false },
					},
					{
						path: 'commission',
						name: 'personal-request-commission',
						component: loadView('Service/Personal/Request/Commission'),
						meta: { auth: false },
					},
				],
			},
			{
				path: 'asset',
				name: 'personal-asset',
				component: emptyComponent,
				redirect: { name: 'personal-asset-wallet' },
				meta: { auth: false },
				children: [
					{
						path: 'wallet',
						name: 'personal-asset-wallet',
						component: loadView('Service/Personal/Asset/Wallet'),
						meta: { auth: false },
					},
					{
						path: 'account',
						name: 'personal-asset-account',
						component: loadView('Service/Personal/Asset/Account'),
						meta: { auth: false },
					},
					{
						path: 'jpys',
						name: 'personal-asset-jpys',
						component: loadView('Service/Personal/Asset/Jpys'),
						meta: { auth: false },
					},
					{
						path: 'sale',
						name: 'personal-asset-sale',
						component: loadView('Service/Personal/Asset/Sale'),
						meta: { auth: false },
					},
					{
						path: 'exchange',
						name: 'personal-asset-exchange',
						component: loadView('Service/Personal/Asset/Exchange'),
						meta: { auth: false },
					},
				],
			},
		],
	},
	{
		path: '/business',
		name: 'business',
		component: loadView('Layout/Layout'),
		redirect: { name: 'business-how-start' },
		props: { sub_page: true },
		meta: { auth: false },
		children: [
			{
				path: 'how',
				name: 'business-how',
				meta: { auth: false },
				component: emptyComponent,
				redirect: { name: 'business-how-start' },
				children: [
					{
						path: 'start',
						name: 'business-how-start',
						component: loadView('Service/Business/How/Start'),
						meta: { auth: false },
					},
					{
						path: 'solution',
						name: 'business-how-solution',
						component: loadView(''),
						meta: { auth: false },
					},
					{
						path: 'receive',
						name: 'business-how-receive',
						component: loadView('Service/Business/How/Receive'),
						meta: { auth: false },
					},
					{
						path: 'pay',
						name: 'business-how-pay',
						component: loadView('Service/Business/How/Pay'),
						meta: { auth: false },
					},
					{
						path: 'risk',
						name: 'business-how-risk',
						component: loadView('Service/Business/How/Risk'),
						meta: { auth: false },
					},
				],
			},
			{
				path: 'operation',
				name: 'business-operation',
				component: emptyComponent,
				redirect: { name: 'business-operation-corps' },
				meta: { auth: false },
				children: [
					{
						path: 'corps',
						name: 'business-operation-corps',
						component: loadView('Service/Business/Operation/Corps'),
						meta: { auth: false },
					},
					{
						path: 'platform',
						name: 'business-operation-platform',
						component: loadView('Service/Business/Operation/Platform'),
						meta: { auth: false },
					},
					{
						path: 'pay',
						name: 'business-operation-pay',
						component: loadView('Service/Business/Operation/Pay'),
						meta: { auth: false },
					},
					{
						path: 'global',
						name: 'business-operation-global',
						component: loadView('Service/Business/Operation/Global'),
						meta: { auth: false },
					},
				],
			},
			{
				path: 'asset',
				name: 'business-asset',
				meta: { auth: false },
				component: loadView(''),
			},
			{
				path: 'pay',
				name: 'business-asset-pay',
				component: loadView('Service/Business/Asset/Pay'),
				meta: { auth: false },
			},
		],
	},

	// 개발 페이지 development
	{
		path: '/development/main',
		name: 'development-main',
		component: loadView('Layout/DevelopLayout'),
		meta: { auth: false },
		props: { develop: true, m_develop: true },
		// redirect: { name: 'development-main' },
		children: [
			{
				path: '',
				name: 'develop-home',
				meta: { auth: false },
				component: loadView('Development/DevelopMain'),
			},
		],
	},

	{
		path: '/service/cs',
		component: loadView('Layout/Layout'),
		meta: { auth: false },
		children: [
			{
				path: 'cs',
				name: 'cs',
				component: loadView('Service/Cs/Cs'),
				meta: { auth: false },
			},
			{
				path: 'faq',
				name: 'faq',
				component: loadView('Service/Cs/Faq'),
				meta: { auth: false },
			},
			{
				path: 'inquiry',
				name: 'inquiry',
				component: loadView('Service/Cs/Inquiry'),
				meta: { auth: false },
			},
			{
				path: 'inquiry_detail',
				name: 'inquiry_detail',
				component: loadView('Service/Cs/InquiryDetail'),
				meta: { auth: false },
			},
			{
				path: 'notice',
				name: 'notice',
				component: loadView('Service/Cs/Notice'),
				meta: { auth: false },
			},
		],
	},
	{
		path: '/pay',
		name: 'pay',
		component: loadView('Layout/Layout'),
		meta: { auth: true },
		children: [
			{
				path: 'payment',
				name: 'pay-payment',
				component: loadView('User/Pay/Payment'),
				meta: { auth: true },
				props: true,
			},
			{
				path: 'deposit',
				name: 'pay-deposit',
				component: loadView('User/Pay/Deposit'),
				meta: { auth: true },
				props: true,
			},
			{
				path: 'exchange',
				name: 'pay-exchange',
				component: loadView('User/Pay/Exchange'),
				meta: { auth: true },
				props: true,
			},
			{
				path: 'c2c',
				name: 'pay-c2c',
				component: loadView('User/Pay/C2c'),
				meta: { auth: true },
				props: true,
			},
			{
				path: 'contacts',
				name: 'pay-contacts',
				component: loadView('User/Pay/Contacts'),
				meta: { auth: true },
			},
			{
				path: 'invoice',
				name: 'pay-invoice',
				component: loadView('User/Pay/Invoice'),
				meta: { auth: true },
			},
		],
	},
	{
		path: '/wallet_account',
		name: 'wallet_account',
		component: loadView('Layout/Layout'),
		meta: { auth: true },
		children: [
			{
				path: 'wallet',
				name: 'wallet_account-wallet',
				component: loadView('User/WalletAccount/Wallet'),
				meta: { auth: true },
			},
			{
				path: 'account',
				name: 'wallet_account-account',
				component: loadView('User/WalletAccount/Account'),
				meta: { auth: true },
			},
			{
				path: 'assets',
				name: 'wallet_account-assets',
				component: loadView('User/WalletAccount/AssetsList'),
				meta: { auth: true },
			},
		],
	},
	{
		path: '/activity',
		component: loadView('Layout/Layout'),
		meta: { auth: true },
		children: [
			{
				path: '',
				name: 'activity',
				component: loadView('User/Activity/Activity'),
				meta: { auth: true },
			},
			{
				path: 'exchange',
				name: 'activity-exchange',
				component: loadView('User/Activity/Exchange'),
				meta: { auth: true },
			},
			{
				path: 'c2c',
				name: 'activity-c2c',
				component: loadView('User/Activity/C2c'),
				meta: { auth: true },
			},
			{
				path: 'invoice',
				name: 'activity-invoice',
				component: loadView('User/Activity/Invoice'),
				meta: { auth: true },
			},
			// {
			// 	path: 'sale_detail',
			// 	name: 'activity-sale_detail_list',
			// 	component: loadView('User/Activity/SaleDetailList'),
			// 	meta: { auth: true },
			// },
		],
	},
	{
		path: '/user/cs',
		component: loadView('Layout/Layout'),
		meta: { auth: true },
		children: [
			{
				path: 'cs',
				name: 'user-cs',
				component: loadView('User/Cs/Cs'),
				meta: { auth: true },
			},
			{
				path: 'faq',
				name: 'user-faq',
				component: loadView('User/Cs/Faq'),
				meta: { auth: true },
			},
			{
				path: 'inquiry',
				name: 'user-inquiry',
				component: loadView('User/Cs/Inquiry'),
				meta: { auth: true },
			},
			{
				path: 'inquiry_list',
				name: 'user-inquiry_list',
				component: loadView('User/Cs/InquiryList'),
				meta: { auth: true },
			},
			{
				path: 'inquiry_detail',
				name: 'user-inquiry-detail',
				component: loadView('User/Cs/InquiryDetail'),
				meta: { auth: true },
			},
			{
				path: 'notice',
				name: 'user-notice',
				component: loadView('User/Cs/Notice'),
				meta: { auth: true },
			},
		],
	},
	{
		path: '/help',
		name: 'help',
		component: loadView(''),
		meta: { auth: true, sub: true },
	},
	{
		path: '/setting',
		name: 'setting',
		component: loadView(''),
		meta: { auth: true, sub: true },
		children: [
			{
				path: 'security',
				name: 'setting-security',
				component: loadView('Pay/Payment'),
				meta: { auth: true },
			},
			{
				path: 'payment',
				name: 'setting-payment',
				component: loadView('Pay/Contacts'),
				meta: { auth: true },
			},
			{
				path: 'notice',
				name: 'setting-notice',
				component: loadView(''),
				meta: { auth: true },
			},
		],
	},
	{
		path: '/mypage',
		name: 'mypage',
		component: loadView('Layout/Layout'),
		meta: { auth: true, sub: true },
		children: [
			{
				path: 'account',
				name: 'mypage-account',
				component: loadView('Mypage/Account'),
				meta: { auth: true },
			},
			{
				path: 'data',
				name: 'mypage-data',
				component: loadView('Mypage/Data'),
				meta: { auth: true },
			},
			{
				path: 'certification',
				name: 'mypage-certification',
				component: loadView('Mypage/Certification'),
				meta: { auth: true },
			},
			{
				path: 'seller_tool',
				name: 'mypage-seller_tool',
				component: loadView(''),
				meta: { auth: true },
			},
		],
	},
	{
		path: '/merchant-console/:merchant_seq/catalog',
		component: loadView('Layout/MerchantLayout'),
		children: [
			{
				path: '',
				name: 'merchant-console-catalog',
				component: loadView('Merchant/Catalog'),
				meta: { auth: true },
			},
		],
	},
	{
		path: '/merchant-console/:merchant_seq/transaction-list',
		component: loadView('Layout/MerchantLayout'),
		children: [
			{
				path: '',
				name: 'merchant-console-transaction-list',
				component: loadView('Merchant/Transaction/TransactionList'),
				meta: { auth: true },
			},
		],
	},
	{
		path: '/merchant-console/:merchant_seq/settlement_account',
		component: loadView('Layout/MerchantLayout'),
		children: [
			{
				path: '',
				name: 'merchant-console-settlement_account',
				component: loadView('Merchant/Settlement/SettlementAccount'),
				meta: { auth: true },
			},
		],
	},
	{
		path: '/merchant-console/:merchant_seq',
		component: loadView('Layout/MerchantLayout'),
		props: { lnb: true },
		redirect: { name: 'merchant-console-catalog' },
		children: [
			{
				path: 'cs/notice',
				name: 'merchant-console-cs-notice',
				component: loadView('Merchant/Cs/Notice'),
				meta: { auth: true },
			},
			{
				path: 'cs/inquiry_list',
				name: 'merchant-console-cs-inquiry-list',
				component: loadView('Merchant/Cs/InquiryList'),
				meta: { auth: true },
			},
			{
				path: 'cs/inquiry_detail',
				name: 'merchant-console-cs-inquiry-detail',
				component: loadView('Merchant/Cs/InquiryDetail'),
				meta: { auth: true },
			},
			{
				path: 'cs/inquiry',
				name: 'merchant-console-cs-inquiry',
				component: loadView('Merchant/Cs/Inquiry'),
				meta: { auth: true },
			},
			{
				path: 'cs/faq',
				name: 'merchant-console-cs-faq',
				component: loadView('Merchant/Cs/Faq'),
				meta: { auth: true },
			},
			{
				path: 'certification/kyc',
				name: 'merchant-console-certification-kyc',
				component: loadView('Merchant/Certification/Kyc'),
				meta: { auth: true },
			},
			{
				path: 'certification/email',
				name: 'merchant-console-certification-email',
				component: loadView('Merchant/Certification/Email'),
				meta: { auth: true },
			},
			{
				path: 'certification/otp',
				name: 'merchant-console-certification-otp',
				component: loadView('Merchant/Certification/Otp'),
				meta: { auth: true },
			},
			{
				path: 'certification/address',
				name: 'merchant-console-certification-address',
				component: loadView('Merchant/Certification/Address'),
				meta: { auth: true },
			},
			{
				path: 'certification/security',
				name: 'merchant-console-certification-security',
				component: loadView('Merchant/Certification/Security'),
				meta: { auth: true },
			},
		],
	},
	{
		path: '/terms',
		name: 'terms',
		component: loadView('Layout/Layout'),
		redirect: { name: 'agreement1' },
		meta: { auth: false },
		props: { terms: true, m_terms: true },
		children: [
			{
				name: 'term_area',
				path: '',
				component: loadView('Terms'),
				meta: { auth: false },
				children: [
					{
						path: 'terms/franchise_agreement',
						name: 'agreement1',
						component: loadView('Terms/FranchiseAgreement/Agreement1'),
						meta: { auth: false },
					},
					{
						path: 'terms/franchise_agreement',
						name: 'agreement2',
						component: loadView('Terms/FranchiseAgreement/Agreement2'),
						meta: { auth: false },
					},
					{
						path: 'terms/franchise_agreement',
						name: 'agreement3',
						component: loadView('Terms/FranchiseAgreement/Agreement3'),
						meta: { auth: false },
					},
					{
						path: 'terms/franchise_agreement',
						name: 'agreement4',
						component: loadView('Terms/FranchiseAgreement/Agreement4'),
						meta: { auth: false },
					},
					{
						path: 'terms/franchise_agreement',
						name: 'agreement5',
						component: loadView('Terms/FranchiseAgreement/Agreement5'),
						meta: { auth: false },
					},
					{
						path: 'terms/franchise_agreement',
						name: 'agreement6',
						component: loadView('Terms/FranchiseAgreement/Agreement6'),
						meta: { auth: false },
					},
					{
						path: 'terms/franchise_agreement',
						name: 'agreement7',
						component: loadView('Terms/FranchiseAgreement/Agreement7'),
						meta: { auth: false },
					},
					{
						path: 'terms/franchise_agreement',
						name: 'agreement8',
						component: loadView('Terms/FranchiseAgreement/Agreement8'),
						meta: { auth: false },
					},
					{
						path: 'terms/franchise_agreement',
						name: 'agreement9',
						component: loadView('Terms/FranchiseAgreement/Agreement9'),
						meta: { auth: false },
					},
					{
						path: 'terms/franchise_agreement',
						name: 'agreement10',
						component: loadView('Terms/FranchiseAgreement/Agreement10'),
						meta: { auth: false },
					},
					{
						path: 'terms/franchise_agreement',
						name: 'agreement11',
						component: loadView('Terms/FranchiseAgreement/Agreement11'),
						meta: { auth: false },
					},
					{
						path: 'terms/franchise_agreement',
						name: 'agreement12',
						component: loadView('Terms/FranchiseAgreement/Agreement12'),
						meta: { auth: false },
					},
					{
						path: 'terms/franchise_agreement',
						name: 'agreement13',
						component: loadView('Terms/FranchiseAgreement/Agreement13'),
						meta: { auth: false },
					},
					{
						path: 'terms/guideline',
						name: 'guideline1',
						component: loadView('Terms/Guideline/Guideline1'),
						meta: { auth: false },
					},
					{
						path: 'terms/guideline',
						name: 'guideline2',
						component: loadView('Terms/Guideline/Guideline2'),
						meta: { auth: false },
					},
					{
						path: 'terms/legal_indication',
						name: 'legal_indication1',
						component: loadView('Terms/LegalIndication/LegalIndication1'),
						meta: { auth: false },
					},
					{
						path: 'terms/legal_indication',
						name: 'legal_indication2',
						component: loadView('Terms/LegalIndication/LegalIndication2'),
						meta: { auth: false },
					},
					{
						path: 'terms/legal_indication',
						name: 'legal_indication3',
						component: loadView('Terms/LegalIndication/LegalIndication3'),
						meta: { auth: false },
					},
					{
						path: 'terms/legal_indication',
						name: 'legal_indication4',
						component: loadView('Terms/LegalIndication/LegalIndication4'),
						meta: { auth: false },
					},
					{
						path: 'terms/legal_indication',
						name: 'legal_indication5',
						component: loadView('Terms/LegalIndication/LegalIndication5'),
						meta: { auth: false },
					},
					{
						path: 'terms/legal_indication',
						name: 'legal_indication6',
						component: loadView('Terms/LegalIndication/LegalIndication6'),
						meta: { auth: false },
					},
					{
						path: 'terms/legal_indication',
						name: 'legal_indication7',
						component: loadView('Terms/LegalIndication/LegalIndication7'),
						meta: { auth: false },
					},
					{
						path: 'terms/legal_indication',
						name: 'legal_indication8',
						component: loadView('Terms/LegalIndication/LegalIndication8'),
						meta: { auth: false },
					},
					{
						path: 'terms/legal_indication',
						name: 'legal_indication9',
						component: loadView('Terms/LegalIndication/LegalIndication9'),
						meta: { auth: false },
					},
					{
						path: 'terms/privacy_policy',
						name: 'privacy_policy1',
						component: loadView('Terms/PrivacyPolicy/PrivacyPolicy1'),
						meta: { auth: false },
					},
					{
						path: 'terms/privacy_policy',
						name: 'privacy_policy2',
						component: loadView('Terms/PrivacyPolicy/PrivacyPolicy2'),
						meta: { auth: false },
					},
					{
						path: 'terms/privacy_policy',
						name: 'privacy_policy3',
						component: loadView('Terms/PrivacyPolicy/PrivacyPolicy3'),
						meta: { auth: false },
					},
				],
			},
		],
	},

	{
		path: '/management',
		name: 'management',
		component: loadView('Layout/ManagementLayout'),
		meta: { auth: false },
		children: [
			{
				path: '',
				name: 'management-login',
				meta: { auth: false },
				component: loadView('Management/Login'),
			},
			{
				path: ':merchant_seq/qr_payment',
				name: 'qr-payment',
				meta: { auth: true },
				component: loadView('Management/QrPayment'),
			},
			{
				path: ':merchant_seq/payment_list',
				name: 'payment-list',
				meta: { auth: true },
				component: loadView('Management/PaymentList'),
			},
			{
				path: ':merchant_seq/merchant_management',
				name: 'merchant-management',
				meth: { auth: true },
				component: loadView('Management/MerchantManagement'),
			},
			{
				path: ':merchant_seq/setup',
				name: 'setup',
				meth: { auth: true },
				component: loadView('Management/Setup'),
			},
			{
				path: ':merchant_seq/setup/notice',
				name: 'setup-notice',
				meth: { auth: true },
				component: loadView('Management/SetupNotice'),
			},
			{
				path: ':merchant_seq/setup/setup_faq',
				name: 'setup-faq',
				component: loadView('Management/SetupFaq'),
				meta: { auth: true },
			},
			{
				path: ':merchant_seq/setup/setup_cs',
				name: 'setup-cs',
				component: loadView('Management/SetupCs'),
				meta: { auth: true },
			},
		],
	},
	// {
	// 	path: '/merchant_management',
	// 	// name: 'merchant-management',
	// 	component: loadView('Layout/ManagementLayout'),
	// 	meta: { auth: true },
	// 	children: [
	// 		{
	// 			path: '',
	// 			name: 'merchant-management',
	// 			component: loadView('Management/MerchantManagement'),
	// 			meta: { auth: true },
	// 		},
	// 	],
	// },
];
